import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import CheckoutForm from '../CheckoutForm';

const STRIPE_PK = process.env.STRIPE_PK; // eslint-disable-line prefer-destructuring
const stripePromise = loadStripe(STRIPE_PK);

const CheckoutFormWrapper = (props) => {
  const { className, currentUser, product, organizationUuid, showEnrollmentForm } = props;

  return (
    <Elements stripe={stripePromise}>
      <ElementsConsumer>
        {({ stripe, elements }) => (
          <CheckoutForm
            className={className}
            stripe={stripe}
            elements={elements}
            currentUser={currentUser}
            showEnrollmentForm={showEnrollmentForm}
            organizationUuid={organizationUuid}
            product={product}
          />
        )}
      </ElementsConsumer>
    </Elements>
  );
};

export default CheckoutFormWrapper;
